<template>
	<div>
		<detected-speed @network-type="handleNetworkIdentified" @network-speed="handleNetworkSpeed"></detected-speed>

		<!-- Offline Dialog -->
        <modal
            class="offline-modal"
            size="small"
            @close="isOffline = false"
            v-if="isOffline">
            <template slot="header">
                <p class="material-icons-warning text-center">warning</p>
                <span class="ml-5">{{ $t('Connection Problem') }}</span>
            </template>
            <template slot="body">
                <!-- <div class="text-center">
                    <p class="material-icons-warning md-15 text-center">warning</p>
                </div> -->
                <div class="text-base">{{ $t('You seems offline, please check your connection') }}.</div>
                <div class="text-sm">{{ $t('Try to refresh, if the problem persist please contact our support') }}</div>
            </template>
            <div slot="footer" class="text-center mt-4 pt-2">
                <button
                    @click="refreshPage"
                    type="submit"
                    class="btn btn-submit btn-primary text-center">
                    {{ $t('Refresh') }}
                </button>
            </div>
		</modal>

		<!-- Slow Dialog -->
        <modal
            class="offline-modal"
            size="small"
            @close="isSlowConnection = false"
            v-if="isSlowConnection">
            <template slot="header">
                <p class="material-icons-warning text-center">warning</p>
                <span class="ml-5">{{ $t('Connection Problem') }}</span>
            </template>
            <template slot="body">
                <!-- <div class="text-center mb-0">
                    <p class="material-icons-warning text-center">warning</p>
                </div> -->
                    <div class="text-base">{{ $t('You seems have a slow internet connection, please check your connection') }}.</div>
                    <div class="text-sm">{{ $t('Try to refresh, if the problem persist please contact our support') }}</div>
            </template>
            <div slot="footer" class="text-center mt-4 pt-2">
                <button
                    @click="refreshPage"
                    type="submit"
                    class="btn btn-submit btn-primary text-center">
                    {{ $t('Refresh') }}
                </button>
            </div>
		</modal>

        <!-- Slow Dialog -->
        <modal
            class="offline-modal"
            size="small"
            @close="onLine = false"
            v-if="!onLine">
            <template slot="header">
                <p class="material-icons-warning text-center">warning</p>
                <span class="ml-5">{{ $t('Connection Problem') }}</span>
            </template>
            <template slot="body">
                <!-- <div class="text-center">
                    <p class="material-icons-warning md-15 text-center">warning</p>
                </div> -->
                <div class="text-base">{{ $t('You seems offline, please check your connection') }}.</div>
                <div class="text-sm">{{ $t('Try to refresh, if the problem persist please contact our support') }}</div>
            </template>
            <div slot="footer" class="text-center mt-4 pt-2">
                <button
                    @click="refreshPage"
                    type="submit"
                    class="btn btn-submit btn-primary text-center">
                    {{ $t('Refresh') }}
                </button>
            </div>
		</modal>
	</div>
</template>

<script>

import DetectedSpeed from 'vue-identify-network';
import Modal from '@/components/Modal.vue';

export default {
	name: 'IdentifyNetwork',
	components: {
		DetectedSpeed,
		Modal,
	},
	props: {},
	mounted() {
		window.addEventListener('online', this.updateOnlineStatus);
		window.addEventListener('offline', this.updateOnlineStatus);
	},
	data: () => ({
		isOffline: false,
		connectionType: '2g',
		isSlowConnection: false,
		onLine: navigator.onLine,
		showBackOnline: false,
	}),
	methods: {
		handleNetworkIdentified(type) {
			this.connectionType = type;
			this.isSlowConnection = this.connectionType === '2g';
		},
		handleNetworkSpeed(speed) {
			this.isOffline = speed === 0;
		},
		refreshPage() {
			window.location.reload();
		},
		updateOnlineStatus(e) {
			const { type } = e;
			this.onLine = type === 'online';
		},
	},
	watch: {
		onLine(v) {
			if (v) {
				this.showBackOnline = true;
				setTimeout(() => { this.showBackOnline = false; }, 1000);
			}
		},
	},
	beforeDestroy() {
		window.removeEventListener('online', this.updateOnlineStatus);
		window.removeEventListener('offline', this.updateOnlineStatus);
	},
};
</script>

<style lang="scss" scoped>
.material-icons-warning {
    position: absolute;
    margin: 0;
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 30px;
	color: #FFA800;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}
.wrapper-offline{
		text-align: center!important;
	}
</style>
